export const signupInitialValues = {
  username: '',
  password: '',
  passwordAgain: '',
  name: '',
  surname: '',
  position: '',
  foot: ''
}
